<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-btn text @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
      </v-col>
      <v-col cols="4" offset="4">
        <v-card color="primary" class="ui-module-card ui-module-fade-in-up">
          <v-card-title class="ui-module-titlebar justify-center font-weight-bold">Movimientos realizados</v-card-title>
          <v-card-text>
            <v-list color="primary">
              <v-list-item v-for="movimiento in movimientos" :key="movimiento.idMovimiento">
                <v-list-item-content>
                  <v-list-item-subtitle>{{ movimiento.CatTipoMovimiento.title }}</v-list-item-subtitle>
                  <v-list-item-title>{{ movimiento.fecha }}</v-list-item-title>
                  <v-list-item-subtitle>{{ movimiento.observaciones }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-avatar color="secondary">
                    <div class="text-overline white--text">{{ movimiento.cantidad }}</div>
                  </v-avatar>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-container>
              <v-row>
                <v-col cols="12" align="center">
                  <div class="text-h6">Cantidad total en inventario: {{ getStock() }}</div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-center ui-module-actions">
            <v-btn text class="error--text mb-4 mx-8 ui-module-btn-text-danger" v-on:click="$router.go(-1)"
              >Salir</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  async mounted() {
    this.fetchMovimientoEquipamientoByItem(this.id)
  },

  props: {
    id: {
      type: Number,
    },
  },

  data() {
    return {}
  },

  computed: {
    ...mapGetters('movimientoEquipamiento', {
      movimientos: 'getMovimientoEquipamiento',
    }),
  },

  methods: {
    ...mapActions('movimientoEquipamiento', ['fetchMovimientoEquipamientoByItem']),

    getStock: function () {
      var stock = 0

      this.movimientos.forEach((movimiento) => {
        stock = stock + movimiento.cantidad
      })

      return stock
    },
  },
}
</script>

<style scoped>
.text-h6 {
  color: #ffbe76 !important;
  font-weight: 700;
}

/* Listas */
::v-deep .v-list {
  background: transparent !important;
}

::v-deep .v-list-item {
  border-radius: 12px;
  margin: 4px 0;
  background: rgba(46, 36, 22, 0.4);
  border: 1px solid rgba(255, 159, 67, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
}

::v-deep .v-list-item:hover {
  background: rgba(255, 159, 67, 0.15);
  border-color: rgba(255, 159, 67, 0.3);
  transform: translateX(8px);
  box-shadow: 0 4px 12px rgba(255, 159, 67, 0.2);
}

::v-deep .v-list-item-title {
  color: #e0e0e0 !important;
  font-weight: 600;
}

::v-deep .v-list-item-subtitle {
  color: rgba(224, 224, 224, 0.7) !important;
}

/* Avatares */
::v-deep .v-avatar {
  background: rgba(255, 159, 67, 0.15) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 159, 67, 0.3);
  transition: all 0.3s ease;
}

::v-deep .v-list-item:hover .v-avatar {
  transform: scale(1.1);
  border-color: #ff9f43;
  box-shadow: 0 8px 24px rgba(255, 159, 67, 0.4);
}

::v-deep .v-avatar .text-overline {
  color: #ffffff !important;
  font-weight: 700;
}

::v-deep .v-btn.error--text:hover {
  background: rgba(255, 82, 82, 0.1) !important;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 159, 67, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 159, 67, 0.6);
}
</style>
